// DrawKing: Conditional Frame Options v3
// Show frame style dropdown only when FRAMED variant is selected
// Uses polling approach for reliability across Dawn section re-renders
(function(){
  function applyFrameToggle(){
    // 1. Find the size/delivery select inside variant-selects
    var vs=document.querySelector('variant-selects');
    if(!vs)return;
    var ss=null,sels=vs.querySelectorAll('select');
    for(var j=0;j<sels.length;j++){
      var fi=sels[j].closest('.product-form__input');
      if(fi){var la=fi.querySelector('label');
        if(la&&(la.textContent.toLowerCase().indexOf('size')!==-1||la.textContent.toLowerCase().indexOf('delivery')!==-1)){ss=sels[j];break;}
      }
    }
    if(!ss)return;
    // 2. Determine if a FRAMED option is selected
    var sel=ss.options[ss.selectedIndex];
    var isFramed=sel?sel.text.toUpperCase().indexOf('FRAMED')!==-1:false;
    // 3. Find all frame style APO options and set visibility
    var opts=document.querySelectorAll('.mw-option');
    for(var i=0;i<opts.length;i++){
      var lb=opts[i].querySelector('.mw-option-title,label');
      if(lb&&lb.textContent.toLowerCase().indexOf('frame style')!==-1){
        opts[i].style.display=isFramed?'':'none';
        if(!isFramed){
          var fs=opts[i].querySelector('select');
          var fh=opts[i].querySelector('input[type="hidden"]');
          if(fs&&fs.selectedIndex!==0){fs.selectedIndex=0;fs.dispatchEvent(new Event('change',{bubbles:true}));}
          if(fh)fh.value='';
        }
      }
    }
  }
  // Poll every 300ms to handle all re-injection scenarios
  setInterval(applyFrameToggle,300);
  // Also run on DOMContentLoaded and immediately
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(applyFrameToggle,800);});}
  else{setTimeout(applyFrameToggle,800);}
})();